var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.52703 6.62838C9.52703 7.09459 9.52703 9.2027 9.52703 9.2027H7.64189V12.3446H9.52703V21H13.3986V12.3446H15.9932C15.9932 12.3446 16.2365 10.8243 16.3581 9.18243C16.0135 9.18243 13.4189 9.18243 13.4189 9.18243C13.4189 9.18243 13.4189 7.35811 13.4189 7.03378C13.4189 6.70946 13.8446 6.28378 14.25 6.28378C14.6757 6.28378 15.5473 6.28378 16.3581 6.28378C16.3581 5.85811 16.3581 4.37838 16.3581 3C15.2635 3 14.027 3 13.4797 3C9.42568 3 9.52703 6.14189 9.52703 6.62838Z","fill":"#191919"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
